import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import useFilterSortJobs from "../../custom hook/useFilterSortJobs";
import { fetchJobs } from "../../features/Job/jobSlice";
import JoblistItem from "./JoblistItem";

export default function Joblist() {
  const dispatch = useDispatch();
  const { error } = useSelector((state) => state.Jobs);
  const jobs = useFilterSortJobs();

  useEffect(() => {
    dispatch(fetchJobs());
  }, []);

  return (
    <div className="jobs-list">
      {/* Single Job 1*/}
      {error ? (
        <p>{error}</p>
      ) : (
        jobs?.map((job) => <JoblistItem key={job.id} job={job} />)
      )}
      {/* Single Job 1*/}
    </div>
  );
}
